var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-friendly-iframe',{style:(_vm.iframeStyles),attrs:{"src":_vm.src,"allow":"clipboard-read; clipboard-write"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }